export default __webpack_public_path__ + "static/media/medicine.44a0b743.svg";